import {useEffect} from 'react';
import {useInView} from 'react-intersection-observer';
import {TitleBar} from '../../../../design-system/organisms/TitleBar/TitleBar';
import {TitleBarType} from '../../../../design-system/organisms/TitleBar/TitleBarType.enum';
import {aggregateAndSendLog} from '../../../../logging/aggregateAndSendLog';
import {putTiaraObjectProps} from '../../../../logging/putTiaraObjectProps';
import {CommonSectionProps} from '../../type';

export function BigBanner({section, children}: CommonSectionProps) {
  const {title} = section;
  const {ref, inView, entry} = useInView();
  useEffect(() => {
    if (inView && entry?.target) {
      aggregateAndSendLog({
        targetElem: entry.target as HTMLElement,
        actionType: 'ViewImp',
        actionName: '섹션_노출',
        customProps: {
          user_action: 'imp',
        },
        viewimp_contents: {
          imp_type: 'vimp',
        },
      });
    }
  }, [entry, inView]);
  return (
    <div
      ref={ref}
      {...putTiaraObjectProps({
        viewimp_contents: {
          imp_id: 'sbanner',
          imp_provider: 'service',
          layer1: '배너',
          id: section.id,
          type: section.type,
          name: title,
        },
        click: {
          imp_id: 'sbanner',
          layer1: '배너',
          imp_provider: 'service',
        },
        customProps: {
          section_title: title,
          section_type: '배너',
        },
      })}
    >
      {!!title && (
        <TitleBar className="mb-4pxr" type={TitleBarType.Main} title={title} />
      )}
      {children}
    </div>
  );
}
